  import { Component, OnInit } from '@angular/core';
import { InstitucionesService } from 'src/app/services/instituciones.service';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';


@Component({
  selector: 'app-escuelas',
  templateUrl: './escuelas.component.html',
  styleUrls: ['./escuelas.component.scss']
})
export class EscuelasComponent implements OnInit {
  enviroment = environment.BASE_URL;

  escuelas:any[] = [];
  private respuestaInstituciones : any;
  private respuestaEstados: any;
  buscar: any;

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  datosItem;
  itemId;
  data;
  imagenActual;
  escudoActual;

  formulario;
  formularioEdit;
  estados;
  respuestaMunicipios:any;
  municipios;
  estadoSelected;
  municipioSelected;

  constructor(private _getInstituciones : InstitucionesService, private _agregarEscuela: CatalogosService, 
    private _editarEscuela:CatalogosService, private _getEstados: CatalogosService, private _getMunicipios: CatalogosService,
    private _updateEscuela: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      pageLength: 20,
      processing: true
    };

      this.getInstituciones();
      this.getEstados();

      this.formulario = {
        'nombre':'',
        imagen: '',
        escudo: '',
        descripcion: '',
        municipio: '',
      }
  
      this.formularioEdit = {
        'nombre':'',
        imagen: '',
        escudo: '',
        descripcion: '',
        municipio: '',
      }
  }

  getInstituciones(){
    this._getInstituciones.getInstituciones().subscribe(
      data => {
        this.respuestaInstituciones = data;
        if(this.respuestaInstituciones.success){
          this.escuelas = this.respuestaInstituciones.content;
          this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
      
  }

  getEstados(){
    this._getEstados.getEstados().subscribe(
      data => {
        this.respuestaEstados = data;
        if(this.respuestaEstados.success){
          this.estados = this.respuestaEstados.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
      
  }

  getMunicipios(estado){
    this.data = {
      'estado':estado,
    }
    console.log(this.data);

    this._getMunicipios.getMunicipios(this.data).subscribe(
      data => {
        this.respuestaMunicipios = data;
        if(this.respuestaMunicipios.success){
          this.municipios = this.respuestaMunicipios.content;
        }
    }, error => console.error(error));
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }


  escudoChange(files: FileList){
    this.formulario.escudo = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.escudo.type.toString() == 'image/png' ||
        this.formulario.escudo.type.toString() == 'image/jpeg' ) {
        if (this.formulario.escudo.size > 10485760) {
          this.formulario.escudo = null;
          $('#escudo').focus();
          return;
        }
        console.log('File Change', this.formulario.escudo);
    } else {
      this.formulario.escudo = null;
      $('#escudo').focus();
      return;
    }
  }

  escudoChangeEdit(files: FileList){
    this.formularioEdit.escudo = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.escudo.type.toString() == 'image/png' ||
        this.formularioEdit.escudo.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.escudo.size > 10485760) {
          this.formularioEdit.escudo = null;
          $('#escudo2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.escudo);
    } else {
      this.formularioEdit.escudo = null;
      $('#escudo2').focus();
      return;
    }
  }

  agregarEscuela(municipioSelect){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('descripcion', this.formulario.descripcion);
    formData.append('municipio', municipioSelect);

    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    if (this.formulario.escudo){ 
      formData.append('escudo', this.formulario.escudo);
    }


    this._agregarEscuela.agregarEscuela(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getInstituciones();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarEscuela(escuela){
    this.data = {
      'escuela':escuela,
    }
    this._editarEscuela.editarEscuela(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.getMunicipios(this.datosItem.estadoid);
          
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.formularioEdit.descripcion = this.datosItem.descripcion;
          this.imagenActual = this.datosItem.imagen;
          this.escudoActual = this.datosItem.escudo;
          this.estadoSelected =  this.datosItem.estadoid;
          this.municipioSelected = this.datosItem.ciudadid;
          this.itemId = escuela; 
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateEscuela(escuela, municipio){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('descripcion', this.formularioEdit.descripcion);
    formData.append('municipio', municipio);
    formData.append('institucion', escuela);

    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    if (this.formularioEdit.escudo){ 
      formData.append('escudo', this.formularioEdit.escudo);
    }

    this._updateEscuela.updateEscuela(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getInstituciones();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

  // search(){
  //   this.escuelas.filter(res =>{
  //     return res.nombre.toLocaleLowerCase().match(this.buscar)
  //   })
  // }


}
